import React from 'react';
import PropTypes from 'prop-types';
import '../../component-styles/Proposal-UI.css';

export default function ProjectSalesTaxWarningModal({ isOpen, docLabel, onClose, onEditProject }) {
  if (!isOpen) return null;

  return (
    <div className="proposal-lock-overlay" onClick={onClose}>
      <div className="proposal-lock-modal" onClick={(e) => e.stopPropagation()}>
        <h3>No sales tax assigned</h3>
        <p>
          This project does not have a sales tax assignment. Review the project settings before
          creating this {docLabel}.
        </p>
        <div className="proposal-lock-actions">
          <button className="if-btn-secondary" onClick={onClose}>
            Continue
          </button>
          <button className="if-btn-primary" onClick={onEditProject}>
            Edit Project
          </button>
        </div>
      </div>
    </div>
  );
}

ProjectSalesTaxWarningModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  docLabel: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onEditProject: PropTypes.func.isRequired,
};

ProjectSalesTaxWarningModal.defaultProps = {
  docLabel: 'document',
};
